import { createFileRoute } from "@tanstack/react-router";
import { SkillEditPage } from "@client/components/tool-workshop/skill-edit-page";

export const Route = createFileRoute("/_app/bots/skills/new")({
  component: SkillEditPage,
});
